import classNames from "classnames";

export const wrapper = classNames("relative", "w-64", "p-4", "justify-self-center","z-10");
export const valueContainer = classNames("flex", "items-center", "justify-between", "font-medium");
export const productList = classNames("absolute", "top-full", "right-0", "bg-secondary", "w-48", "shadow-xl", "max-h-44", "overflow-auto");
export const productItem = classNames("pt-2", "pb-2", "pl-5", "text-left", "hover:bg-gray-300", "hover:bg-opacity-10","hover:text-primary","cursor-pointer");
